import BlogCanvas from "./components/BlogCanvas";
import BlogMetaDataModal from "./components/BlogMetaDataModal";
import CustomCardHeader from "../../components/card/CustomCardHeader";
import CardBody from "../../components/card/CardBody";
import CustomCard from "../../components/card/CustomCard";
import {SemiTransparentButton} from "../../components/CustomButton";
import CustomIcon from "components/CustomIcon";
import BlogTips from "./components/BlogTips";
import PublishBlogButton, {BlogInfoButton} from "./components/PublishBlogButton";


export default function CreateBlogCanvas({blogId}) {

  return (
    <>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <CustomCard>
              <CustomCardHeader color="blue" contentPosition="none" className="pd-y-0">
                <div className="flex items-center justify-between w-full">
                  <h2 className="text-2xl text-white">{blogId ? "Update Blog" : "Create a New Blog"}</h2>

                  <div className="flex items-center space-x-4">
                    <BlogInfoButton/>
                    <PublishBlogButton/>
                  </div>
                </div>
              </CustomCardHeader>
              <CardBody>
                <BlogCanvas blogId={blogId}/>
              </CardBody>
            </CustomCard>

          </div>
        </div>
      </div>
      <BlogMetaDataModal/>
      <BlogTips/>
    </>
  );
}

